'use client';

import { ReactNode } from 'react';

import { cn } from '@/lib/utils/tailwind';

export type HeroBannerProps = {
  media: ReactNode;
  className?: string;
  children: ReactNode;
  as?: 'div' | 'header' | 'section';
  variant?: 'video' | 'default';
};

const HeroBanner = ({
  media,
  children,
  as: Tag = 'div',
  className,
  variant = 'default',
}: HeroBannerProps) => {
  return (
    <Tag
      className={cn(
        '[justify-content:var(--hero-content-vertical-alignment)] relative overflow-hidden group flex flex-col w-full',
        variant === 'video' ? 'aspect-video' : 'sm:aspect-video aspect-square',
        className,
      )}
    >
      <div className="absolute inset-0 z-0 h-full w-full" aria-hidden>
        {media}
      </div>
      <div className="flex flex-col [align-items:var(--hero-content-horizontal-alignment)] z-20">
        {children}
      </div>
    </Tag>
  );
};

export { HeroBanner };
